var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "h4",
        [
          _c("vs-icon", {
            staticClass: "material-icons",
            attrs: { icon: "fingerprint" }
          }),
          _vm._v(" Firmas Digitales")
        ],
        1
      ),
      !_vm.signatures || _vm.signatures.length === 0
        ? _c(
            "div",
            [
              _c("vs-icon", {
                staticClass: "material-icons",
                staticStyle: { color: "orange", cursor: "default" },
                attrs: { icon: "info" }
              }),
              _vm._v(" Este documento no ha sido firmado digitalmente. ")
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.signatures, function(approver, index) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.signatures && _vm.signatures.length > 0,
                expression: "signatures && signatures.length > 0"
              }
            ],
            key: index
          },
          [
            _c(
              "div",
              { staticClass: "aprobaciones d-flex justify-content-between" },
              [
                _c("div", { staticClass: "d-flex flex-row" }, [
                  _c("div", { staticClass: "numero" }, [
                    _vm._v(_vm._s(index + 1))
                  ]),
                  _c("div", { staticClass: "d-flex flex-column" }, [
                    _c("div", { staticClass: "nombre" }, [
                      _vm._v(_vm._s(approver.nombreUsuario))
                    ]),
                    _c("div", { staticClass: "correo" }, [
                      _vm._v(_vm._s(approver.correoUsuario))
                    ])
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column justify-content-between align-items-end"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "proveedor cursor" },
                      [
                        _c(
                          "vs-tooltip",
                          {
                            attrs: {
                              position: "top",
                              text: "Proveedor de Firma"
                            }
                          },
                          [
                            _c("span", { staticClass: "badge badge-primary" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.signatureProvider(
                                      approver.proveedorFirma
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    approver.fecha
                      ? _c(
                          "div",
                          {
                            staticClass: "fecha",
                            attrs: { title: "Fecha de Firma" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(approver.fecha.replace(" ", " a las ")) +
                                " hrs. "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ]
        )
      }),
      _c("hr"),
      _vm.url
        ? _c("div", { staticClass: "text-center" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-warning",
                attrs: { href: _vm.url, target: "_blank" }
              },
              [_vm._v("Ver documento")]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }